import axios from "../../axios";

export const login = async (email, password) => {
  try {
    const response = await axios.post(`/internal/api/auth/login`, {
      email,
      password,
    });
    console.log("response", response)
    return response.data;
  } catch (error) {
    console.log("error", error)
    throw error;
  }
};

export const basic= async () => {
  try {
    const resp = await axios.get(`/api/bsa/v2/user/all/basic`);
    return resp.data;
  } catch (error) {
    throw error;
  }
};
